import './LeadFocusRow.css';

const SOURCE_LABELS = {
  REFERRAL: 'Referral', EVENT: 'Event', WALK_IN: 'Walk-in',
  COLD_CALL: 'Cold call', DIGITAL: 'Digital', OTHER: 'Other'
};

const INTEREST_LABELS = { LOW: 'Low', MEDIUM: 'Medium', HIGH: 'High' };

function formatDate(iso) {
  if (!iso) return null;
  return new Date(iso).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' });
}

export default function LeadFocusRow({ lead, selected, onSelect, onLog }) {
  function handleLogClick(e) {
    e.stopPropagation();
    onLog(lead);
  }

  return (
    <div
      className={`lfr__row ${selected ? 'lfr__row--selected' : ''}`}
      onClick={() => onSelect(lead)}
    >
      <div className="lfr__main">
        <div className="lfr__name">
          {(lead.hot_score || 0) > 70 && '🔥 '}{lead.name}
        </div>
        <div className="lfr__phone">{lead.phone}</div>

        <div className="lfr__chips">
          {lead.source && (
            <span className="lfr__chip lfr__chip--source">
              {SOURCE_LABELS[lead.source] || lead.source}
            </span>
          )}
          {lead.interest_level && (
            <span className={`lfr__chip lfr__chip--interest lfr__chip--${lead.interest_level.toLowerCase()}`}>
              {INTEREST_LABELS[lead.interest_level]}
            </span>
          )}
        </div>

        <div className="lfr__meta">
          {lead.last_contacted_at && (
            <span className="lfr__meta-item">Last: {formatDate(lead.last_contacted_at)}</span>
          )}
          {lead.next_follow_up_at && (
            <span className="lfr__meta-item lfr__meta-item--due">Due: {formatDate(lead.next_follow_up_at)}</span>
          )}
        </div>
      </div>

      <button className="lfr__log-btn" onClick={handleLogClick}>Log</button>
    </div>
  );
}
